import Header from '../components/header';

export default function Contact(){
  return(
    <>
      <Header />
      <h2>Contact Page</h2>
    </>
  )
}